import { detectIsInLti } from './detection';

/**
 * Non-hook LTI detection. Prefer {@link useIsInLti} in React components so
 * renders stay reactive to LtiContextManager mutations and route changes.
 *
 * Delegates to the shared `detectIsInLti` so hook and non-hook callers agree.
 */
export function isInLtiContext(): boolean {
  return detectIsInLti();
}
